import * as Yup from "yup";

import {
  TextField as MuiTextField,
  Paper,
  Typography,
} from "@material-ui/core";
import React, { useEffect } from "react";
import {
  dummyInternalSignInPortAuth,
  internalSignInPortAuth,
} from "../../redux/actions/authActions";
import InternalCallback from "../../pages/auth/InternalCallback";

import { Alert as MuiAlert } from "@material-ui/lab";
import { PORT_AUTH_LOGIN_URL } from "../../constants";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

const InternalSignIn = () => {
  // console.log(InternalSignIn);
  useEffect(() => {
    window.location.href = PORT_AUTH_LOGIN_URL;
  });

  return <Typography>Redirecting...</Typography>;
};

export default InternalSignIn;
